"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _solarReact = require("@solar/solar-react");

var _RepresentativeInfo = _interopRequireDefault(require("./RepresentativeInfo"));

var _excluded = ["representative", "history", "action"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// import TodoMessage from '../TodoMessage';
// import ContactsInfo from '../Contact/ContactsInfo';
// import CertificateList from '../Certificate/CertificateList';
var RepresentativeSheet = function RepresentativeSheet(_ref) {
  var representative = _ref.representative,
      history = _ref.history,
      action = _ref.action,
      other = _objectWithoutProperties(_ref, _excluded);

  var person = representative.person;
  var fullName = person.fullName,
      avatar = person.avatar; // const tabs = {
  //   info: {
  //     label: 'Info',
  //     component: <RepresentativeInfo representative={representative} person={person} {...other} />,
  //   },
  //   // favorites: {
  //   //   label: 'Favorieten',
  //   //   component: <TodoMessage message="Wordt opgeleverd in fase 2" />,
  //   // },
  //   // Requests: {
  //   //   label: 'Aanvragen',
  //   //   component: <TodoMessage message="Wordt opgeleverd in fase 2" />,
  //   // },
  //   // certificateChanges: {
  //   //   label: 'Certificaatwijzigingen',
  //   //   component: <TodoMessage message="Wordt opgeleverd in fase 1" />,
  //   // },
  //   // crmChanges: {
  //   //   label: 'wijzigingen CRM',
  //   //   component: <TodoMessage message="Wordt opgeleverd in fase 1" />,
  //   // },
  // };
  // return <CoverTabView title={fullName} cover={avatar && avatar.src} tabs={tabs} action={action} />;

  return /*#__PURE__*/_react["default"].createElement(_solarReact.CoverView, {
    title: fullName,
    cover: avatar && avatar.src,
    action: action
  }, /*#__PURE__*/_react["default"].createElement(_RepresentativeInfo["default"], _extends({
    representative: representative,
    person: person
  }, other)));
};

var _default = RepresentativeSheet;
exports["default"] = _default;